function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#F4F4F4",
  strokeWidth: ".5",
  d: "M2.68 17a1.6 1.6 0 01-1.6-1.6V2.6A1.6 1.6 0 012.68 1h8.36a1.6 1.6 0 011.6 1.6v1.6a.8.8 0 11-1.6 0V2.6H2.68v12.8h8.36v-1.6a.8.8 0 111.6 0v1.6a1.6 1.6 0 01-1.6 1.6H2.68zm8.062-11.79l3.268 3.22a.799.799 0 010 1.14l-3.266 3.22a.8.8 0 01-1.124-1.14l1.876-1.85H5.54a.8.8 0 110-1.6h5.956L9.618 6.35a.8.8 0 011.124-1.14z",
  opacity: ".54"
})));